






/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../helpers";
// PublishPost
// PUBLISHPOST
const GETCUSTOMERINFOFORREAPPROVAL= createAsyncThunk(
  "getCustomerInfoForReapproval/getCustomerInfoForReapproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCustomerInfoForReapprovalSlice = createSlice({
  name: "getCustomerInfoForReapprovalSlice",
  initialState: {
    getCustomerInfoForReapproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCustomerInfoForReapproval: (state) => {
        state.getCustomerInfoForReapproval.loading = false
        state.getCustomerInfoForReapproval.error = false
        state.getCustomerInfoForReapproval.data = []
        state.getCustomerInfoForReapproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCUSTOMERINFOFORREAPPROVAL.fulfilled, (state, action) => {
      state.getCustomerInfoForReapproval = {
        ...state.getCustomerInfoForReapproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERINFOFORREAPPROVAL.pending, (state, action) => {
      state.getCustomerInfoForReapproval = {
        ...state.getCustomerInfoForReapproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERINFOFORREAPPROVAL.rejected, (state, action) => {
      state.getCustomerInfoForReapproval = {
        ...state.getCustomerInfoForReapproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCustomerInfoForReapprovalAction = {
    GETCUSTOMERINFOFORREAPPROVAL,
};

export { getCustomerInfoForReapprovalAction };
export default getCustomerInfoForReapprovalSlice.reducer;
export const {setInitialStateOfgetCustomerInfoForReapproval} = getCustomerInfoForReapprovalSlice.actions
